import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../../firebase";
import type { FactoringStatusType } from "components/FactoringStatus";

interface Request {
  userId: string;
  factoringId: string;
  desiredAmount: number;
  notes: string;
  notification: string;
  notificationDate: string;
  requireAdditionalImages: boolean;
  applicationNumber: string;
  applicationDate: string;
  status: FactoringStatusType;
}

interface Response {
  success: boolean;
  message: string;
}

interface Props extends Request {

}

export const updateFactoringDetail = async (data: Props) => {
  const functions = getFirebaseFunctions();

  const updateFactoringDetailFunction = httpsCallable<Request, Response>(
    functions,
    "admin_updateFactoringDetail",
  );

  try {
    const res = await updateFactoringDetailFunction(data);
    return res.data;
  } catch (error) {
    console.error("Failed to update factoring detail:", error);
    throw error;
  }
};
